const translations = {
  "en": {
    "Account connections": "Account connections",
    "Cross-domain reasoning": "Cross-domain reasoning",
    "Daily Brief · 5/day": "Daily Brief · 5/day",
    "Daily Money Brief": "Daily Money Brief",
    "Desk · 2 notes": "Desk · 2 notes",
    "Desk · unlimited notes": "Desk · unlimited notes",
    "Desk notes": "Desk notes",
    "Ed Complete · For life": "Ed Complete · For life",
    "Founding Ambassador badge": "Founding Ambassador badge",
    "Invest & Plan, unlimited": "Invest & Plan, unlimited",
    "Investment + Planning · Unlimited": "Investment + Planning · Unlimited",
    "Locked-in pricing": "Locked-in pricing",
    "Money Scan": "Money Scan",
    "Money Scan · 3 actions": "Money Scan · 3 actions",
    "Plan tab · demo": "Plan tab · demo",
    "Private beta access": "Private beta access",
    "Private Financial Vault": "Private Financial Vault",
    "Your full Money Plan": "Your full Money Plan"
  },
  "zh-tw": {
    "Account connections": "帳號連接",
    "Cross-domain reasoning": "跨領域推理",
    "Daily Brief · 5/day": "每日簡報 · 5/天",
    "Daily Money Brief": "每日財經簡報",
    "Desk · 2 notes": "工作台 · 2 則筆記",
    "Desk · unlimited notes": "Desk · 無限筆記",
    "Desk notes": "桌面筆記",
    "Ed Complete · For life": "Ed Complete · 終身",
    "Founding Ambassador badge": "創始大使徽章",
    "Invest & Plan, unlimited": "投資與規劃，無限可能",
    "Investment + Planning · Unlimited": "投資 + 規劃 · 無限",
    "Locked-in pricing": "鎖定價格",
    "Money Scan": "金錢掃描",
    "Money Scan · 3 actions": "金錢掃描 · 3 個動作",
    "Plan tab · demo": "計畫標籤 · 範例",
    "Private beta access": "私人測試版權限",
    "Private Financial Vault": "私人財務金庫",
    "Your full Money Plan": "你完整的理財計畫"
  }
};

export default translations;
